import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'

import AlertDialog from './AlertDialog';

import { setCovidNoticeDismissed } from '../actions';

import {isTrue} from '../utils';

const CovidNotice = () => {
	const dispatch = useDispatch();
	
	const generalSettings = useSelector(state => state.settings.general.data);
	const user = useSelector(state => state.user);
	const member = useSelector(state => state.member.data);
	const memberLabels = useSelector(state => state.settings.labels_members.data);
	const memberSettings = useSelector(state => state.settings.members.data);
	const noticeDismissed = useSelector(state => state.covidNoticeDismissed);
	const timedOut = useSelector(state => state.timedOutLoggedOut);
	
	const [noticeRequired, setNoticeRequired] = useState(false);
	useEffect(() => {
		
		let r = false;
		if(isTrue(generalSettings.vaccine_rules_on) && !noticeDismissed && !timedOut){
			if(user.member_no === 0){
				r = true;
			} else if(user.member_no > 0 && !isTrue(member.vaccinated) && !isTrue(member.distance_member_type)){
				r = true;
			}
		} 
		setNoticeRequired(r);
		
	}, [generalSettings, user, member, noticeDismissed, timedOut])
	


	return noticeRequired ? 
		<AlertDialog 
			noBackdropClick={true}
			title='COVID-19 Vaccination Requirement'
			message={user.member_no > 0 ? (
			memberSettings.vax_message_member || 'Members can only attend face-to-face classes if ' + memberLabels.fully_vaccinated + '. If you are ' + memberLabels.fully_vaccinated + ', please update your Member details and tick the appropriate box. Proof of vaccination will be required.'
			) : (
			memberSettings.vax_message_join || 'Members can only attend face-to-face classes if ' + memberLabels.fully_vaccinated + ' against COVID-19. If ' + memberLabels.fully_vaccinated + ', make sure you tick the appropriate box on the last page of the Join form. Proof of vaccination will be required.'
			)}
			handleClose={() => dispatch(setCovidNoticeDismissed(true))}
		/> : 
		null;
}

export default CovidNotice